<template>
<div class="chapter">
<div class="inner_page">
<h2 class="heading">I<span class="smallcaps">NDEX OF </span>C<span class="smallcaps">HARACTERS</span></h2>
<p class="negative"><strong>The Cerullo family (the shoemaker’s family):</strong></p>
<p class="negative"><em class="italic">Fernando Cerullo</em>,<em class="italic"> </em>shoemaker.</p>
<p class="negative"><em class="italic">Nunzia Cerullo</em>,<em class="italic"> </em>wife of Fernando and Lila’s mother.</p>
<p class="negative"><em class="italic">Raffaella Cerullo</em>,<em class="italic"> </em>called <em class="italic">Lina</em>, and<em class="italic"> </em>by Elena<em class="italic"> Lila</em>. </p>
<p class="negative"><em class="italic">Rino Cerullo</em>,<em class="italic"> </em>Lila’s older brother, also a shoemaker. </p>
<p class="negative"><em class="italic">Rino</em>, also the name of one of Lila’s children.</p>
<p class="negative"><em class="italic">Other children.</em></p>
<p class="negative"><em class="italic"> </em></p>
<p class="negative"><strong>The Greco family (the porter’s family):</strong></p>
<p class="negative"><em class="italic">Elena Greco</em>,<em class="italic"> </em>called <em class="italic">Lenuccia </em>or <em class="italic">Lenù. </em>She is the oldest, and after her are <em class="italic">Peppe</em>,<em class="italic"> Gianni</em>,<em class="italic"> </em>and <em class="italic">Elisa.</em></p>
<p class="negative">The <em class="italic">father</em> is a porter at the city hall.</p>
<p class="negative">The <em class="italic">mother</em> is a housewife.</p>
<p class="negative"> </p>
<p class="negative"><strong>The Carracci family (Don Achille’s family):</strong></p>
<p class="negative"><em class="italic">Don Achille Carracci</em>,<em class="italic"> </em>the ogre of fairy tales.</p>
<p class="negative"><em class="italic">Maria Carracci</em>,<em class="italic"> </em>wife of Don Achille.</p>
<p class="negative"><em class="italic">Stefano Carracci</em>,<em class="italic"> </em>son of Don Achille, grocer in the family store.</p>
<p class="negative"><em class="italic">Pinuccia </em>and <em class="italic">Alfonso Carracci</em>,<em class="italic"> </em>Don Achille’s two other children.</p>
<p class="negative"> </p>
<p class="negative"><strong>The Peluso family (the carpenter’s family):</strong></p>
<p class="negative"><em class="italic">Alfredo Peluso</em>, carpenter.</p>
<p class="negative"><em class="italic">Giuseppina Peluso</em>, wife of Alfredo.</p>
<p class="negative"><em class="italic">Pasquale Peluso</em>, older son of Alfredo and Giuseppina, construction worker.</p>
<p class="negative"><em class="italic">Carmela Peluso</em>, who is also called <em class="italic">Carmen</em>, sister of Pasquale, salesclerk in a dry-goods store.</p>
<p class="negative"><em class="italic">Other children</em>.</p>
<p class="negative"> </p>
<p class="negative"><strong>The Cappuccio family (the mad widow’s family):</strong></p>
<p class="negative"><em class="italic">Melina</em>, a relative of Lila’s mother, a mad widow.</p>
<p class="negative">Melina’s <em class="italic">husband</em>, who unloaded crates at the fruit and vegetable market.</p>
<p class="negative"><em class="italic">Ada Cappuccio</em>, Melina’s daughter.</p>
<p class="negative"><em class="italic">Antonio Cappuccio</em>, her brother, a mechanic.</p>
<p class="negative"><em class="italic">Other children</em>.</p>
<p class="negative"> </p>
<p class="negative"><strong>The Sarratore family (the railroad worker poet’s family):</strong></p>
<p class="negative"><em class="italic">Donato Sarratore</em>, conductor.</p>
<p class="negative"><em class="italic">Lidia Sarratore</em>, wife of Donato.</p>
<p class="negative"><em class="italic">Nino Sarratore</em>, the oldest of the five children of Donato and Lidia.</p>
<p class="negative"><em class="italic">Marisa Sarratore</em>, daughter of Donato and Lidia.</p>
<p class="negative"><em class="italic">Pino</em>,<em class="italic"> Clelia</em>, and <em class="italic">Ciro Sarratore</em>, younger children of Donato and Lidia.</p>
<p class="negative"> </p>
<p class="negative"><strong>The Scanno family (the fruit and vegetable seller’s family):</strong></p>
<p class="negative"><em class="italic">Nicola Scanno</em>, fruit and vegetable seller.</p>
<p class="negative"><em class="italic">Assunta Scanno</em>, wife of Nicola.</p>
<p class="negative"><em class="italic">Enzo Scanno</em>, son of Nicola and Assunta, also a fruit and vegetable seller.</p>
<p class="negative"><em class="italic">Other children</em>.</p>
<p class="negative"> </p>
<p class="negative"><strong>The Solara family (the family of the owner of the Solara bar-pastry shop):</strong></p>
<p class="negative"><em class="italic">Silvio Solara</em>, owner of the bar-pastry shop.</p>
<p class="negative"><em class="italic">Manuela</em> <em class="italic">Solara</em>, wife of Silvio.</p>
<p class="negative"><em class="italic">Marcello </em>and<em class="italic"> Michele Solara</em>, sons of Silvio and Manuela.</p>
<p class="negative"> </p>
<p class="negative"><strong>The Spagnuolo family (the baker’s family):</strong></p>
<p class="negative"><em class="italic">Signor Spagnuolo</em>, pastry maker at the bar-pastry shop Solara.</p>
<p class="negative"><em class="italic">Rosa Spagnuolo</em>, wife of the pastry maker.</p>
<p class="negative"><em class="italic">Gigliola Spagnuolo</em>, daughter of the pastry maker.</p>
<p class="negative"><em class="italic">Other children</em>.</p>
<p class="negative"> </p>
<p class="negative"><strong>Gino</strong>, son of the pharmacist.</p>
<p class="negative"> </p>
<p class="negative"><strong>The teachers:</strong></p>
<p class="negative"><em class="italic">Maestro Ferraro</em>, teacher and librarian.</p>
<p class="negative"><em class="italic">Maestra Oliviero</em>, teacher.</p>
<p class="negative"><em class="italic">Professor Gerace</em>, high school teacher.</p>
<p class="negative"><em class="italic">Professor Galiani</em>, high school teacher.</p>
<p class="negative"> </p>
<p class="negative"><em class="italic">Nella Incardo</em>, Maestra Oliviero’s cousin, who lives on Ischia.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// neapolitan-novels-boxed-set_00002.vue?569a5cf6